import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    draftId: null,
    fwfTemplates: [],
    pagination: {
        page: 1,
        size: 10,
        totalElements: 0,
        totalPages: 0,
    },
    templateData: {
        name: "",
        scope: "TEMPLATE",
        encoding: "UTF_8",
        lineEnding: "CRLF",
        padCharacter: " ",
        includeHeader: false,
        columns: [],
    },
    isEdit: false,
    editId: "",
    originalScope: "",
}

const fwfTemplateSlice = createSlice({
    name: "fwfTemplate",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },

        setTemplates: (state, action) => {
            state.fwfTemplates = action.payload;
        },

        setPagination: (state, action) => {
            state.pagination = action.payload;
        },
        setTemplateData: (state, action) => {
            state.templateData = action.payload;
        },
        updateTemplateField: (state, action) => {
            const { field, value } = action.payload;
            state.templateData[field] = value;
        },
        addColumn: (state, action) => {
            state.templateData.columns.push(action.payload);
        },
        updateColumn: (state, action) => {
            const { index, updatedColumn } = action.payload;
            state.templateData.columns[index] = {
                ...state.templateData.columns[index],
                ...updatedColumn,
            };
        },
        deleteColumn: (state, action) => {
            state.templateData.columns.splice(action.payload, 1);
        },
        setDraftId: (state, action) => {
            state.draftId = action.payload;
        },
        setIsEdit: (state, action) => {
            state.isEdit = action.payload;
        },
        setEditId: (state, action) => {
            state.editId = action.payload;
        },
        resetTemplate: (state) => {
            state.templateData = initialState.templateData;
            state.isEdit = false;
            state.editId = "";
        }
    }
});
export const fwfTemplateAction = fwfTemplateSlice.actions;
export const fwfTemplateReducer = fwfTemplateSlice.reducer;